import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller.ts"
import { WorkPeriodTemplateActivity } from "@/models/work-period-template-activity.model.ts"
import type { IWorkPeriodTemplateActivity } from "@/interfaces/api/work-period-template-activity.interface.ts"
import { WorkPeriodTemplateActivityRepository } from "@/repositories/work-period-template-activity-repository.ts"
import type { IStoreFunctionsConfig } from "@/store/base-functions/base-store-functions.ts"

export class WorkPeriodTemplateActivityController extends GenericModelController<
  WorkPeriodTemplateActivity,
  IWorkPeriodTemplateActivity,
  WorkPeriodTemplateActivityRepository
> {
  constructor(storeFunctionsConfig?: IStoreFunctionsConfig<WorkPeriodTemplateActivity>) {
    if (!storeFunctionsConfig) {
      // Template activities are managed within their parent WorkPeriodTemplate's `activities`
      // array by the caller, so this controller only persists them (no dedicated collection).
      storeFunctionsConfig = {
        managed: false
      }
    }

    super(
      WorkPeriodTemplateActivity,
      storeFunctionsConfig,
      new WorkPeriodTemplateActivityRepository()
    )
  }
}
